module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/private-library_666ae8.jpg";